import { CheckinPassengerFragment, GdsServiceFragment, PassengerFragment } from '@websky/graphql';

export function buildServiceKey(rfisc: string, passengerId: string, segmentId: string): string {
	return `${rfisc}_${passengerId}_${segmentId}`;
}

/**
 * Формирует Set ключей выбранных GDS-услуг для всех пассажиров.
 * Формат ключа `${rfisc}_${passengerId}_${segmentId}`
 */
export function buildSelectedGdsServiceKeys(
	travellers: PassengerFragment[] | CheckinPassengerFragment[],
	gdsServicesById: Record<string, GdsServiceFragment>
): Set<string> {
	const selectedKeys = new Set<string>();

	travellers.forEach(traveller => {
		traveller.services?.gdsServices?.services?.forEach(selectedService => {
			const isSelected = selectedService.count > 0 || selectedService.confirmedCount > 0;

			if (!isSelected) {
				return;
			}

			const rfisc = gdsServicesById[selectedService.serviceId]?.rfisc;

			if (!rfisc) {
				return;
			}

			selectedService.segmentIds?.forEach(segmentId => {
				selectedKeys.add(buildServiceKey(rfisc, traveller.id, segmentId));
			});
		});
	});

	return selectedKeys;
}
